import {
  IconBulb,
  IconLayoutDashboard,
  IconMicrophoneFilled,
  //IconMicrophoneFilled,
} from '@tabler/icons-react'
import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react'
import { type SidebarData } from '../types'

export const sidebarData: SidebarData = {
  user: {
    name: 'satnaing',
    email: 'satnaingdev@gmail.com',
    avatar: '/avatars/shadcn.jpg',
  },
  teams: [
    {
      name: 'Quivo',
      logo: Command,
      plan: 'Vite + ShadcnUI',
    },
    {
      name: 'Acme Inc',
      logo: GalleryVerticalEnd,
      plan: 'Enterprise',
    },
    {
      name: 'Acme Corp.',
      logo: AudioWaveform,
      plan: 'Startup',
    },
  ],
  navGroups: [
    {
      title: 'Ações',
      items: [
        {
          title: 'Início',
          url: '/',
          icon: IconLayoutDashboard,
        },
        /*{
          title: 'Tasks',
          url: '/tasks',
          icon: IconChecklist,
        },
        {
          title: 'Apps',
          url: '/apps',
          icon: IconPackages,
        },*/
        {
          title: 'Estrategias',
          url: '/chats',
          //badge: '3',
          icon: IconBulb,
        },
        {
          title: 'Áudio',
          url: '/audio',
          //badge: '3',
          icon: IconMicrophoneFilled,
        },
        /*{
          title: 'Users',
          url: '/users',
          icon: IconUsers,
        },*/
      ],
    },
    /* {
       title: 'Pages',
       items: [
         {
           title: 'Auth',
           icon: IconLockAccess,
           items: [
             {
               title: 'Sign In',
               url: '/sign-in',
             },
             {
               title: 'Sign In (2 Col)',
               url: '/sign-in-2',
             },
             {
               title: 'Sign Up',
               url: '/sign-up',
             },
             {
               title: 'Forgot Password',
               url: '/forgot-password',
             },
             {
               title: 'OTP',
               url: '/otp',
             },
           ],
         },
         {
           title: 'Errors',
           icon: IconBug,
           items: [
             {
               title: 'Unauthorized',
               url: '/401',
               icon: IconLock,
             },
             {
               title: 'Forbidden',
               url: '/403',
               icon: IconUserOff,
             },
             {
               title: 'Not Found',
               url: '/404',
               icon: IconError404,
             },
             {
               title: 'Internal Server Error',
               url: '/500',
               icon: IconServerOff,
             },
             {
               title: 'Maintenance Error',
               url: '/503',
               icon: IconBarrierBlock,
             },
           ],
         },
       ],
     },*/
    /*s  {
        title: 'Other',
        items: [
          {
            title: 'Settings',
            icon: IconSettings,
            items: [
              {
                title: 'Profile',
                url: '/settings',
                icon: IconUserCog,
              },
              {
                title: 'Account',
                url: '/settings/account',
                icon: IconTool,
              },
              {
                title: 'Appearance',
                url: '/settings/appearance',
                icon: IconPalette,
              },
              {
                title: 'Notifications',
                url: '/settings/notifications',
                icon: IconNotification,
              },
              {
                title: 'Display',
                url: '/settings/display',
                icon: IconBrowserCheck,
              },
            ],
          },
          {
            title: 'Central de Ajuda',
            url: '/help-center',
            icon: IconHelp,
          },
        ],
      },*/
  ],
}
